// extracted by mini-css-extract-plugin
export var change = "_3z-1";
export var changeList = "_3z-0";
export var changePath = "_3z-2";
export var diffArrow = "_3z-5";
export var diffRow = "_3z-3";
export var diffValue = "_3z-4";
export var error = "_3z-8";
export var notice = "_3z-9";
export var result = "_3z-6";
export var success = "_3z-7";